import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { COPY } from "../constants";
import { rv } from "../tokens";
import { ClockIcon } from "../ui/icons";
import StatusPill from "../ui/StatusPill";

const useStyles = makeStyles((theme) => ({
  wrap: {
    maxWidth: 560,
    margin: "0 auto",
    padding: theme.spacing(6, 2),
    textAlign: "center",
  },
  ring: {
    width: 76,
    height: 76,
    borderRadius: "50%",
    background: rv.pendingBg,
    border: `2px solid ${rv.pendingBorder}`,
    color: rv.pendingFg,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto",
  },
  title: {
    fontWeight: 700,
    fontSize: 24,
    color: rv.heading,
    margin: theme.spacing(2.5, 0, 1),
  },
  body: {
    color: rv.muted,
    fontSize: 14.5,
    lineHeight: 1.6,
    maxWidth: 460,
    margin: "0 auto",
  },
  pill: { marginTop: theme.spacing(2) },
  primary: {
    marginTop: theme.spacing(3),
    background: rv.gold,
    color: rv.onDark,
    minHeight: 44,
    minWidth: 180,
    borderRadius: rv.radiusInput,
    boxShadow: "none",
    textTransform: "none",
    fontWeight: 700,
    "&:hover": { background: rv.goldHover },
  },
}));

interface Props {
  onReturnDashboard: () => void;
}

export default function PendingBlock({ onReturnDashboard }: Props) {
  const classes = useStyles();
  return (
    <div className={classes.wrap}>
      <div className={classes.ring}>
        <ClockIcon size={36} />
      </div>
      <h1 className={classes.title}>{COPY.pending.title}</h1>
      <p className={classes.body}>{COPY.pending.body}</p>
      <div className={classes.pill}>
        <StatusPill tone="pending" icon={<ClockIcon size={12} />}>
          {COPY.pending.pill}
        </StatusPill>
      </div>
      <div>
        <Button variant="contained" className={classes.primary} onClick={onReturnDashboard}>
          {COPY.pending.primary}
        </Button>
      </div>
    </div>
  );
}
